import { homeBoxesService } from '@/services/home-boxes.service';
import { HomeBoxesAdmin } from './HomeBoxesAdmin';

export const HomeBoxes = () => (
  <HomeBoxesAdmin pageTitle="Gestion des boxes home (Notre Collection)" boxesService={homeBoxesService} />
);
